module.exports = __webpack_public_path__ + "static/media/404.7dd98154.png";